import { quadtree } from 'd3-quadtree'
import constant from 'd3-force/src/constant'
import jiggle from 'd3-force/src/jiggle'

function x (d) {
	return d.x + d.vx
}

function y (d) {
	return d.y + d.vy
}

export default function (radius, criteria) {
	let nodes
	let radii
	let random
	let strength = 1
	let iterations = 1

	if (typeof radius !== 'function') radius = constant(radius == null ? 1 : +radius)

	function force () {
		let i
		const n = nodes.length
		let tree
		let node
		let xi
		let yi
		let ri
		let ri2

		for (let k = 0; k < iterations; ++k) {
			tree = quadtree(nodes, x, y).visitAfter(prepare)
			for (i = 0; i < n; ++i) {
				node = nodes[i]
				ri = radii[node.index]
				ri2 = ri * ri
				xi = node.x + node.vx
				yi = node.y + node.vy
				tree.visit(apply)
			}
		}

		function apply (quad, x0, y0, x1, y1) {
			const data = quad.data
			let rj = quad.r
			let r = ri + rj
			if (data) {
				if (data.index > node.index) {
					let x = xi - data.x - data.vx
					let y = yi - data.y - data.vy
					let l = x * x + y * y
					if (l < r * r) {
						if (x === 0) {
							x = jiggle(random)
							l += x * x
						}
						if (y === 0) {
							y = jiggle(random)
							l += y * y
						}
						l = (r - (l = Math.sqrt(l))) / l * strength
						node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj))
						node.vy += (y *= l) * r
						data.vx -= x * (r = 1 - r)
						data.vy -= y * r
					}
				}
				return
			}
			return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r
		}
	}

	function prepare (quad) {
		if (quad.data) {
			quad.r = radii[quad.data.index]
			return quad.r
		}
		for (let i = quad.r = 0; i < 4; ++i) {
			if (quad[i] && quad[i].r > quad.r) {
				quad.r = quad[i].r
			}
		}
	}

	function initialize () {
		if (!nodes) return
		let i
		const n = nodes.length
		let node
		radii = new Array(n)
		for (i = 0; i < n; ++i) {
			node = nodes[i]
			radii[node.index] = +radius(node, i, nodes)
		}
	}

	force.initialize = function (_, __) {
		nodes = _.filter(criteria)
		random = __
		initialize()
	}

	force.iterations = function (_) {
		if (arguments.length) {
			iterations = +_
			return force
		} else {
			return iterations
		}
	}

	force.strength = function (_) {
		if (arguments.length) {
			strength = +_
			return force
		} else {
			return strength
		}
	}

	force.radius = function (_) {
		if (arguments.length) {
			radius = typeof _ === 'function' ? _ : constant(+_)
			initialize()
			return force
		} else {
			return radius
		}
	}

	return force
}
